export const openPrintWindow = (title) => {
  let printWindow = null;

  try {
    printWindow = window.open("", "_blank");
  } catch (error) {
    printWindow = null;
  }

  if (!printWindow) {
    throw new Error(`Unable to open print window for ${title || "document"}`);
  }

  try {
    printWindow.opener = null;
  } catch (error) {
    // Ignore if the browser does not allow overriding opener on this window.
  }

  return printWindow;
};
